<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { initFlowbite } from 'flowbite'
onMounted(() => {
    initFlowbite();
})

// defineProps(['messages'])

const messages = ref([]);

async function getChairmanMessage() {
    try {
        const res = await axios.get('/get-chairman-message-data');
        messages.value = res.data || [];
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getChairmanMessage();
})





const loadMoreText = ref('false')
const loadMore = () => {
    return loadMoreText.value = !loadMoreText.value
}
</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 mx-auto">
            <div
                class="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-6 xl:mt-12 sm:mt-6 xl:mb-12 mb-6 2xl:px-80 xl:px-72 lg:px-36 mx-auto">
                <div v-for="(message, index) in messages" :key="index" class="mx-auto">

                    <button :data-modal-target="index" :data-modal-toggle="index">
                        <div>
                            <h3
                                class="title-font lg:text-2xl text-xl xl:mb-4 mb-2 xl:mt-0 lg:mt-4 xl:pt-6 sm:pt-2 mt-0 text-center text-black">
                                {{ message?.label }}</h3>
                            <div
                                class="rounded shadow-lg shadow-gray-300 mx-auto lg:w-full  wow animate__animated animate__fadeInLeft">
                                <div class="lg:w-full w-72 sm:h-80 h-72 block rounded-t overflow-hidden">
                                    <img :src="message?.image" :alt="message?.name"
                                        class="w-full lg:h-80 h-full object-cover transform hover:scale-110 transition duration-500" loading="lazy" />
                                </div>
                                <div class="lg:p-4 p-2">
                                    <div>
                                        <h3
                                            class="title-font lg:text-xl text-lg font-semibold text-black text-center mb-2">
                                            {{ message?.name }}</h3>
                                        <div class="leading-relaxed mb-2 text-black text-center lg:text-lg text-base">
                                            <p>{{ message?.position }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </button>

                    <div :id="index" tabindex="-1" aria-hidden="true"
                        class="fixed z-50 items-center justify-center bg-black bg-opacity-25 backdrop-filter backdrop-blur-sm sm:overflow-x-hidden right-0 left-0 inset-0 h-screen overflow-auto scroll-smooth  hidden rounded-md">
                        <div class="relative p-4 w-full max-w-2xl max-h-full rounded-md">
                            <div class="bg-white relative shadow dark:bg-gray-700 rounded-md">
                                <button type="button"
                                    class="text-gray-800 bg-transparent hover:bg-gray-200 hover:text-gray-900 text-sm w-8 h-8 ms-auto inline-flex justify-center items-center float-right dark:hover:bg-gray-600 dark:hover:text-white"
                                    :data-modal-hide="index">
                                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 14 14">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                    </svg>
                                    <span class="sr-only">Close modal</span>
                                </button>
                                <div class="flex justify-center items-center sm:p-6 p-4 sm:pr-6 pr-0">
                                    <div class="mx-auto">
                                        <div
                                            class="sm:w-[220px] w-[220px] h-[250px] flex items-center justify-center mx-auto">
                                            <img :src="message?.image"
                                                class="h-full w-full object-cover object-top rounded-2xl inline-block"
                                                :alt="message?.position" loading="lazy">
                                        </div>
                                        <h4
                                            class="py-2 sm:px-6 px-2 bg-[#4BBFD1] rounded-xl text-center title-font sm:text-3xl text-lg font-semibold text-gray-700 sm:mt-6 mt-4 leading-relaxed">
                                            {{ message?.title }}</h4>
                                    </div>
                                </div>
                                <div class="sm:p-8 p-4 sm:pt-0 pt-0 space-y-3">
                                    <div v-show="loadMoreText"
                                        class="sm:text-base text-sm leading-relaxed text-black font-light font-roboto"
                                        v-html="message?.content.slice(0, 435)"></div>
                                    <div v-show="!loadMoreText"
                                        class="sm:text-base text-sm leading-relaxed text-black font-light font-roboto"
                                        v-html="message?.content"></div>
                                    <div v-show="!loadMoreText" class="">
                                        <div class="w-40">
                                            <VLazyImage :src="message?.sign_image" :alt="message?.title" class="object-cover object-center rounded" />
                                        </div>
                                        <h4
                                            class="title-font sm:text-xl text-sm font-semibold text-black leading-relaxed">
                                            {{ message?.name }}</h4>
                                        <p class=" text-black sm:text-xl text-sm font-semibold">{{ message?.position }}
                                        </p>
                                        <p class=" text-black sm:text-xl text-sm font-semibold">{{ message?.company }}
                                        </p>
                                    </div>

                                    <span @click="loadMore" class="inline-block sm:text-base text-sm leading-relaxed text-[#3dcae0] font-light font-roboto cursor-pointer">
                                        {{ loadMoreText ? $t('partner.show_more') : $t('partner.show_less') }}
                                        <i class="fa-solid fa-angles-right pl-1"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
